import type { Lot } from '../../types/lot'
import { filterInteractiveLots } from '../../utils/lotInteraction'

/**
 * Resolves the pond → lot relationship for a lot-scoped Crew Mode capture
 * flow (Charter D-3). Shared by Feed and Mortality (and any future
 * lot-scoped stream) — the pond-first, lot-second resolution is identical
 * across them. Only currently-`Active` lots are selectable, mirroring the
 * `interactiveLots` pattern the admin screens already use
 * (`filterInteractiveLots`). Returns:
 * - `{ kind: 'none' }` when the pond has no active lot — the capture is
 *   blocked at the client per D-3 ("blocked, not silently dropped").
 * - `{ kind: 'single', lot }` when exactly one active lot exists — resolves
 *   automatically, no extra tap.
 * - `{ kind: 'choice', lots }` when more than one exists — the operator
 *   picks.
 */
export type ResolvedPondLots =
  | { kind: 'none' }
  | { kind: 'single'; lot: Lot }
  | { kind: 'choice'; lots: Lot[] }

export const resolvePondLots = (lotsForProductionUnit: Lot[]): ResolvedPondLots => {
  const interactive = filterInteractiveLots(lotsForProductionUnit)
  if (interactive.length === 0) return { kind: 'none' }
  if (interactive.length === 1) return { kind: 'single', lot: interactive[0] }
  return { kind: 'choice', lots: interactive }
}
